module.exports = __webpack_public_path__ + "static/media/privacy_policy_admin.ebcb32f3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/privacy_policy_admin.pdf
// module id = 170
// module chunks = 29